import { render, staticRenderFns } from "./LeaveUpdatesTab.vue?vue&type=template&id=d6398886"
import script from "./LeaveUpdatesTab.vue?vue&type=script&lang=js"
export * from "./LeaveUpdatesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports